import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
import { IOption } from '../../../../models/product-detail';
import '../../../inputs/select-input.css';

interface OptionsSelectDropDownprops {
    name: string;
    label?: string;
    options: IOption[];
    onChange?: (event: React.ChangeEvent<any>) => void;
    hasDefaultOption?: boolean;
    defaultOption?: string;
    value?: string | number;
    error?: string;
    required?: boolean;
    labelClassName?: string;
    fieldClassName?: string;
    disabled?: boolean;
    inlineStyle?: object;
    customLabel?: boolean;
}

const OptionsSelectDropDown = ({
    name,
    label,
    options,
    onChange,
    hasDefaultOption,
    defaultOption,
    value,
    error,
    required,
    labelClassName,
    fieldClassName,
    disabled,
    inlineStyle,
    customLabel,
}: OptionsSelectDropDownprops) => {
    const intl = useIntl();
    let wrapperClass = 'form-group';
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <div className={wrapperClass}>
            {label &&
                (!customLabel ? (
                    <label
                        className={
                            labelClassName
                                ? 'control-label ' + labelClassName
                                : 'control-label col-sm-4'
                        }
                        htmlFor={name}
                    >
                        {label}:
                    </label>
                ) : (
                    <label
                        className={
                            labelClassName
                                ? 'control-label ' + labelClassName
                                : 'control-label col-sm-4'
                        }
                        htmlFor={name}
                        style={{ textTransform: 'none' }}
                    >
                        {label}{' '}
                        {required && (
                            <span
                                className="fas fa-asterisk required-red"
                                style={{ fontSize: '8px' }}
                            />
                        )}
                    </label>
                ))}
            <div
                className={
                    fieldClassName
                        ? 'field ' + fieldClassName
                        : 'field col-sm-8'
                }
            >
                <div className={required ? 'input-group' : ''}>
                    {/* Note, value is set here rather than on the option - docs: https://facebook.github.io/react/docs/forms.html */}
                    <select
                        name={name}
                        value={
                            (value =
                                value || value === 0 ? value : defaultOption)
                        }
                        onChange={onChange}
                        className="form-control"
                        disabled={disabled}
                        style={inlineStyle}
                    >
                        {hasDefaultOption && (
                            <option value="">
                                {intl.formatMessage({
                                    id: defaultOption
                                        ? defaultOption
                                              .replace(' ', '_')
                                              .replace('&', 'AND')
                                              .replace('...', '')
                                        : '',
                                    defaultMessage: defaultOption
                                        ? defaultOption
                                        : '',
                                })}
                            </option>
                        )}
                        {options.map((option, i) => {
                            if (option) {
                                return (
                                    <option
                                        key={option.name + i.toString()}
                                        value={option.id}
                                    >
                                        {intl.formatMessage({
                                            id: option.english
                                                ? option.english
                                                      .replace(/ /g, '_')
                                                      .replace('&', 'AND')
                                                : option.name
                                                      .replace(/ /g, '_')
                                                      .replace('&', 'AND'),
                                            defaultMessage: option.name,
                                        })}
                                    </option>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </select>
                </div>
                {/* {error && <div className="alert alert-danger">{error}</div>} */}
            </div>
        </div>
    );
};

export default OptionsSelectDropDown;
